import { Component, Output, EventEmitter, ElementRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { Globals } from '../../../globals';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { URLDialog } from '../URLDialog/URLDialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvApiService } from 'src/app/API/invapi.service';
import { ImageViewerDialog } from '../ImageViewerDialog/ImageViewerDialog';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'singleattachment',
  templateUrl: './SingleAttachmentComponent.html'
})
export class SingleAttachmentComponent {
  public PrevAttachments = [];
  public DocId;
  public UploadBy;
  public ImagePath = '';
  public ImageName = '';
  @Input() category: string = '';
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  public moduleName = '';
  @Input() isUploadDisabled : boolean = false;
  extension: string;
  @Input() fileName: string = '';   
  urlDialogRef: MatDialogRef<URLDialog>;
  @Output()
  RaiseError = new EventEmitter();
  public uploadID = 'ng2Fileuploader';
  public imageHeight: string = '200px';

  public uploader: FileUploader = new FileUploader({
    url: '',
   autoUpload: true,
    method: 'POST',
    allowedFileType: ['image', 'doc', 'ppt', 'pdf', 'xls'],
    maxFileSize: 20 * 1024 * 1024
  });
public previewMinHeight: string = '80px';
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = item => {
      item.withCredentials = false;
       AppComponent.ShowLoader();
    };
   this.uploader.onCompleteItem = (
      item: any,
      response: any
    ) => {
      const json = JSON.parse(response);
      item.index = json.uploadfilename;

      this.invapi.GetSasUrl('uploads', json.uploadfilename).subscribe(res => {
        this.ImagePath = res.url;    
        this.ImageName = item.file.name;
        this.extension = this.ImageName.split('.').pop()?.toLowerCase();
        AppComponent.HideLoader();
      });
  };
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
  }

  constructor(public dialog: MatDialog,  private invapi: InvApiService) {}

  ngOnInit() {
    const uploadCategory = this.category || 'default';
    if (this.category === 'contact_signature') {

    this.uploader.setOptions({
      url: Globals.apiUrl +
        `Files/Upload?containerName=uploads&category=${uploadCategory}`,
      allowedFileType: ['image']
    });

  } else {

    this.uploader.setOptions({
      url: Globals.apiUrl +
        `Files/Upload?containerName=uploads&category=${uploadCategory}`,
      allowedFileType: ['image', 'doc', 'ppt', 'pdf', 'xls']
    });
  }
    this.uploader.setOptions({
      url: Globals.apiUrl +
        `Files/Upload?containerName=uploads&category=${uploadCategory}`
    });
    this.uploader.autoUpload = true;

      if (this.fileName) {
      this.loadFileFromServer(this.fileName);
      }

    this.setImageHeight();
  }

  private setImageHeight(): void {
    switch (this.category) {
      case 'inventoryequipment_detail':
        this.imageHeight = '220px';
        this.previewMinHeight = '220px';
        break;
      case 'inventorypart_detail':
        this.imageHeight = '220px';
        this.previewMinHeight = '220px';
        break;
      case 'contact_signature':
        this.imageHeight = '80px';
        this.previewMinHeight = '0px';
        break;
      default:
        this.imageHeight = '80px';
        this.previewMinHeight = '0px';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['category'] && changes['category'].currentValue == 'contact_signature') {
      this.loadFileFromServer(changes['fileName'].currentValue);
    }

    if (changes['fileName'] && changes['fileName'].currentValue) {
      this.loadFileFromServer(changes['fileName'].currentValue);
    }
  }

  private loadFileFromServer(fileName: string) {
    if (!fileName) return;

    this.invapi.GetSasUrl('uploads', this.category +'/' + fileName).subscribe(res => {
      this.ImagePath = res.url;
      this.ImageName = fileName;
      this.extension = fileName.split('.').pop()?.toLowerCase();
    });
  }

  public clearQueue() {
    this.uploader.clearQueue();
  }

  public Queue() {
    return this.uploader.queue;
  }

  public SetQueue(Queue) {
    this.uploader.queue = Queue;
  }

  UploadFiles() {
     document.getElementById(this.uploadID).click();
  }

  SetAttachmentUrl(fileName) {
    return Globals.AttachmentUrl + '/' + fileName;
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    let errorMessage;
    switch (filter.name) {
        case 'fileSize':
            errorMessage = `Maximum upload size exceeded (${Math.round((item.size / 1024 / 1024))} MB of 20 MB allowed)`;
            break;
        case 'mimeType':
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, JPEG)'`;
            break;
        default:
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, JPEG)'`;
    }
      this.RaiseError.emit(errorMessage);
  }
 
  reset(){
    this.ImagePath = '';
    this.ImageName = '';
    this.extension = '';
    this.uploader.clearQueue();
  }
 
  openFile(): void {
    if (['png','jpg','jpeg','gif'].includes(this.extension)) {
      // IMAGE DIALOG
      this.dialog.open(ImageViewerDialog, {
        position: { right: '0', top: '0' },
        height: '100%',
        width: '70%',
        data: {
          imgURL: this.ImagePath,
          title: this.ImageName
        }
      });
    } 
    else {
      // DOCUMENT / PDF DIALOG
      this.urlDialogRef = this.dialog.open(URLDialog, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
      });

      this.urlDialogRef.componentInstance.URL = this.ImagePath;
      this.urlDialogRef.componentInstance.dialogRef.updateSize('80%', '100%');
      this.urlDialogRef.componentInstance.PageTitle = this.ImageName;

      this.urlDialogRef.afterClosed().subscribe(() => {
        this.urlDialogRef = null;
      });
    }
  }
    
}
